import { useContext, useEffect } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { AppContext } from "../../contexts/AppContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Colour } from "../Variables";
import { EmailLogRow } from "../components/EmailLogRow";
import { EmailCardRow } from "../components/EmailCardRow";

export function EmailLog() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);

    useEffect(() => {
        routeContext.setRoutes([{ name: "Email log", route: null }])
    }, []);

    return (<>
        <InfoBanner
            narrow={true}
            header="Email log"
            icon={InfoHeaderIcon.Email}
            info={"A log of emails from within the AllHires system"}
            subHeader={`${app.firmName} Online Application System`}
            theme={Colour.White}>
        </InfoBanner>

        <div className="card shadow mb-3">
            <div className="overflow-scroll-table widescreen-only">
                <table className="ListingTable table mt-0 mb-0">
                    <thead className="table-secondary">
                        <tr>
                            <th><i className="fa-solid fa-user me-1"></i> From</th>
                            <th><i className="fa-solid fa-pen-to-square me-1"></i> Subject</th>
                            <th><i className="fa-solid fa-calendar-days me-1"></i> Date</th>
                            {app.emailLogs?.showMailto && <th className=""></th>}
                            <th className="col-fit-content"></th>
                        </tr>
                    </thead>
                    <tbody className="">
                        {app.emailLogs != null && app.emailLogs.emails.map(el => {
                            let date = new Date(el.DateAndTime);
                            let dateID = `${date.getFullYear()}_${date.getMonth()}_${date.getDay()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${date.getMilliseconds()}`;

                            return <EmailLogRow log={el} showMailto={app.emailLogs.showMailto} key={dateID}></EmailLogRow>;
                        })}
                    </tbody>
                </table>
            </div>

            {app.emailLogs != null && app.emailLogs.emails.map(el => {
                let date = new Date(el.DateAndTime);
                let dateID = `${date.getFullYear()}_${date.getMonth()}_${date.getDay()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${date.getMilliseconds()}`;

                return <div className="card-body mob-only"><EmailCardRow log={el} showMailto={app.emailLogs.showMailto} key={dateID}></EmailCardRow></div>;
            })}
        </div>
    </>
    );
}